



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import {format} from 'date-fns';

@Component({
  components: {
  },
})
export default class MiniProgress extends Vue {

  @Prop({ type: Number, default: 100})
  private target!: number;

  @Prop({ type: String, default: '#13C2C2'})
  private color!: string;

  @Prop({ type: Number, default: 78})
  private percent: number = 78;

  @Prop({ type: String, default: '8px'})
  private height: string = '8px';
}
